import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/* =========================================================
   SERVICE WORKER REGISTRATION
========================================================= */

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration =
        await navigator.serviceWorker.register(
          "/service-worker.js",
          {
            updateViaCache: "none",
          }
        );

      console.log(
        "[Service Worker] Registered:",
        registration.scope
      );

      /*
        Check for a newer service worker every time
        the application loads.
      */
      await registration.update();

      registration.addEventListener(
        "updatefound",
        () => {
          const newWorker =
            registration.installing;

          if (!newWorker) {
            return;
          }

          newWorker.addEventListener(
            "statechange",
            () => {
              if (
                newWorker.state ===
                  "installed" &&
                navigator.serviceWorker.controller
              ) {
                console.log(
                  "[Service Worker] New version installed"
                );
              }
            }
          );
        }
      );
    } catch (error) {
      console.error(
        "[Service Worker] Registration failed:",
        error
      );
    }
  });

  let refreshing = false;

  navigator.serviceWorker.addEventListener(
    "controllerchange",
    () => {
      if (refreshing) {
        return;
      }

      refreshing = true;
      window.location.reload();
    }
  );
}

reportWebVitals();